var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminTable',{attrs:{"id":"admin-user-balance-deposit","columns":_vm.columns,"title":`Коллекция userbalancedeposits`,"model-name":"userBalanceDepositModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }